import { getIdToken } from "@/services/Auth";
import { getDefaultHeaders, request } from "@/utils/CreativeIntelligenceApi";

export async function getSataliaDomains(baseUrl: string) {
    const url = `${baseUrl}/v1/satalia/domains`;
    const token = await getIdToken();
    const headers = getDefaultHeaders(token);

    return request<string[]>(url, headers);
}
